import { useMemo } from 'react';

import { DEFAULT_RADIUS } from 'src/components/InfiniteJobList/useQueryJobsCount';
import useQueryJobsIds from 'src/components/RelatedOffers/useQueryJobsIds';

export const SIMILAR_JOBS_RADIUS = 100;

const useRelatedOffers = (
  keyword?: string,
  lat?: number,
  lng?: number,
  radius = DEFAULT_RADIUS,
  take = 20,
  skip = false
) => {
  /** Original search job ids */
  const allJobsQuery = useQueryJobsIds(keyword, lat, lng, radius, take, undefined, skip);

  /** Section 1 - same keyword and city but widen radius */
  const similarJobsQuery = useQueryJobsIds(
    keyword,
    lat,
    lng,
    SIMILAR_JOBS_RADIUS,
    take,
    'SIMILAR_OFFERS',
    skip
  );
  /** Section 2 - same city and radius but no keyword */
  const nearbyJobsQuery = useQueryJobsIds(undefined, lat, lng, radius, take, 'NEARBY_OFFERS', skip);

  const similarJobsIds = useMemo(() => {
    return similarJobsQuery.ids?.filter((id) => !allJobsQuery.ids?.includes(id));
  }, [allJobsQuery.ids, similarJobsQuery.ids]);
  const nearbyJobsIds = useMemo(() => {
    return nearbyJobsQuery.ids?.filter((id) => !allJobsQuery.ids?.includes(id));
  }, [nearbyJobsQuery.ids, similarJobsQuery.ids]);

  const loading = allJobsQuery.loading || similarJobsQuery.loading || nearbyJobsQuery.loading;
  const error = allJobsQuery.error || similarJobsQuery.error || nearbyJobsQuery.error;

  return { similarJobsIds, nearbyJobsIds, loading, error };
};

export default useRelatedOffers;
